import { leanplumStore } from 'stores';
import { EXPERIMENTS, GATEWAY_GOOGLEPLAY, GATEWAY_ITUNES } from 'config';

export const useExperimentCheckoutSteps = (plan) => {
    if (!plan) {
        return {
            steps: [],
            checkoutType: '',
        };
    }

    const checkoutType = leanplumStore.experiment(EXPERIMENTS.CHECKOUT_FLOW);
    const steps = [];

    if (!plan.has_all_instruments) {
        steps.push('instruments');
    }

    if (checkoutType === 'wizard') {
        steps.push('overview');

        if (!plan.is_yearly_monthly) {
            steps.push('method');
        }
    }

    steps.push('payment');

    return {
        steps,
        checkoutType,
    };
};

export const useWizardCheckout = (plan) => {
    if (!plan) {
        return {
            steps: [],
            checkoutType: '',
        };
    }

    const steps = [];

    if (!plan.has_all_instruments) {
        steps.push('instruments');
    }

    steps.push('overview');

    if (!plan.is_yearly_monthly) {
        steps.push('method');
    }

    steps.push('payment');

    return {
        steps,
    };
};
export const useWizardUpgradeCheckout = (plan, subscription) => {
    if (!plan || !subscription) {
        return {
            steps: [],
            checkoutType: '',
        };
    }
    const steps = [];

    steps.push('overview');

    if (
        subscription.gateway === GATEWAY_ITUNES ||
        subscription.gateway === GATEWAY_GOOGLEPLAY
    ) {
        steps.push('payment');
    }
    return {
        steps,
    };
};
